import React from 'react';

export default class GalleryIndexContent extends React.Component {
    constructor( props ) {
        super(props);

    }

    render() {
        return (
            <div>
                <h3 className="bottom-modal__title  margin__bottom--small">
                    Galerie-Verzeichnis
                </h3>

                <ul className="gallery-index">
                    {this.props.currentState.obj.gallery_images.map((image, i) =>
                        <li className="gallery-index__li">
                            <div className="gallery-index__index"><span>{i + 1}</span></div>
                            <div className="gallery-index__title">{image.post_title}</div>
                            <div className="gallery-index__img">
                                <img src={image.post_thumbnail.sizes.thumbnail.url} alt={image.post_title}/>
                            </div>
                        </li>
                    )}
                </ul>
            </div>
        );
    }

}
